/**
 * @generated SignedSource<<6e635ee615ecc39827a6ca565b2d37f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_issueFragmentRef$data = {
  readonly delegator?: {
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_issueFragmentRef";
};
export type assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_issueFragmentRef$key = {
  readonly " $data"?: assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_issueFragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_issueFragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_issueFragmentRef",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "delegator",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "294d67e87f32386955a9ba72713c3937";

export default node;
